import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IToaster } from "../../../../../interface";

@Component({
  selector: "app-toaster-item",
  imports: [NgIf],
  templateUrl: "./toaster-item.component.html",
  styleUrl: "./toaster-item.component.scss"
})
export class ToasterItemComponent {
  @Input() toast: IToaster;
  @Input() i: number;
}
